import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Text from '../base/Text'

import ChipLabel, { ChipLabelProps } from './ChipLabel/ChipLabel'

interface AuctionBidLabelProps {
  isOutbid?: boolean
  sx?: ChipLabelProps['sx']
}

const AuctionBidLabel: RFC<AuctionBidLabelProps> = ({
  isOutbid = false,
  sx = {}
}) => {
  const labelColor = isOutbid ? 'error.main' : 'secondary.main'
  const textColor = isOutbid ? 'background.default' : 'primary.main'
  const width = isOutbid ? 58 : 105

  return (
    <ChipLabel
      startColor={labelColor}
      endColor={labelColor}
      sx={{
        width,
        px: 1,
        py: '1px',
        ...sx
      }}
    >
      <Text
        variant="subtitle2"
        sx={{
          fontWeight: 500,
          color: textColor,
          ...Platform.select({
            web: { lineHeight: '20px' },
            native: { lineHeight: 20 }
          })
        }}
      >
        {isOutbid ? (
          <FormattedMessage defaultMessage="Outbid" />
        ) : (
          <FormattedMessage defaultMessage="Highest Bidder" />
        )}
      </Text>
    </ChipLabel>
  )
}

export default AuctionBidLabel
